import Component from 'generic.basecomponent';
import app from 'app-instance';
import Stickyfill from 'stickyfilljs';
import tableTemplate from '../html/table.hbs';
import basketManager from '../../shop/js/basket-manager';


export default class PaymentSummary extends Component {
    constructor(el) {
        super(el);

        this.onProductChange = this.onProductChange.bind(this);
        this.onDonationChange = this.onDonationChange.bind(this);
        this.renderContainerSelector = '.js-payment-summary__container';
        this.productSelector = '.js-payment-summary__product';
        this.productOptionSelector = '.js-payment-summary__product-option';
        this.productEnableSelector = '.js-payment-summary__add-product';
        this.productPriceSelector = '.js-payment-summary__product-price';

        this.init();
    }

    init() {
        this.renderContainer = this.container.querySelector(this.renderContainerSelector);
        this.productNodes = this.container.querySelectorAll(this.productSelector);


        Stickyfill.add(this.renderContainer);

        app.addListener('donateAmount:input', this.onDonationChange.bind(this));

        for (let i = 0; i < this.productNodes.length; i++) {
            this.productNodes[i].addEventListener('change', this.onProductChange);
        }

        this.data = this.getInitialData();
        this.calcTotal();
        this.render();
    }

    getInitialData() {
        const initialDataString = this.container.getAttribute('data-payment-summary');
        let initialData = {};
        try {
            initialData = JSON.parse(initialDataString);
        } catch (e) {
            console.log(e);
        }

        if (typeof initialData === 'object') {
            for (let i = 0; i < this.productNodes.length; i++) {
                let productInfoObj = {};

                try {
                    productInfoObj = JSON.parse(this.productNodes[i].getAttribute('data-payment-summary-product'));
                    productInfoObj.id = this.productNodes[i].getAttribute('data-payment-summary-product-id');
                } catch (e) {
                    console.log(e);
                }
                const productRadio = this.productNodes[i].querySelector(this.productEnableSelector);
                productInfoObj.isAdded = (productRadio === null) || (productRadio && productRadio.checked);

                const optionNodes = [...this.productNodes[i].querySelectorAll(this.productOptionSelector)];

                productInfoObj.options = this.getInitialOptions(optionNodes);
                productInfoObj.preparedOptions = basketManager.prepareItemOptions(productInfoObj.options);
                productInfoObj.priceNode = this.productNodes[i].querySelector(this.productPriceSelector);


                initialData.items.forEach((item) => {
                    if (typeof item.products === 'undefined') {
                        item.products = [];
                    }
                    if (item.id.toString() === productInfoObj.attendeeId.toString()) {
                        item.products.push(productInfoObj);
                    }
                });
            }
        }

        return initialData;
    }

    getInitialOptions(optionNodes) {
        const options = [];
        optionNodes.forEach((option) => {
            const optionId = option.getAttribute('data-shop-item-option-id');
            options.push({ id: optionId, element: option });
        });

        return options;
    }

    render() {
        this.renderContainer.innerHTML = tableTemplate(this.data);
    }

    onProductChange(e) {
        const productNode = e.currentTarget;

        this.getProductInfo(productNode).then(() => {
            this.calcTotal();
            this.render();
        });
    }

    getProductInfo(productNode) {
        const productRadio = productNode.querySelector(this.productEnableSelector);
        const productId = productNode.getAttribute('data-payment-summary-product-id');
        let productInfoObj = {};

        try {
            productInfoObj = JSON.parse(productNode.getAttribute('data-payment-summary-product'));
        } catch (e) {
            console.log(e);
        }


        const attendeeId = productInfoObj.attendeeId;

        const productInTree = this.getProductInTreeByIds(productId, attendeeId);
        productInTree.isAdded = (productRadio === null) || (productRadio && productRadio.checked);


        if (productInTree.isAdded) {
            const requestBody = this.getPriceRequestBody(productInTree);

            return basketManager.doItemPriceRequest(requestBody).then((result) => {
                productInTree.cost = result.Product.Price;
                productInTree.visualCost = result.Product.FormattedPrice;
                this.updatePriceNode(productInTree);
            });
        }
        return Promise.resolve();
    }

    getProductInTreeByIds(productId, attendeeId) {
        let productInTree;

        this.data.items.some((item, i) => {
            if (item.id.toString() === attendeeId.toString()) {
                item.products.some((product, j) => {
                    if (product.id.toString() === productId.toString()) {
                        productInTree = this.data.items[i].products[j];
                        return true;
                    }
                    return false;
                });
                return true;
            }
            return false;
        });

        return productInTree;
    }

    updatePriceNode(product) {
        product.priceNode.innerHTML = product.visualCost;
    }

    calcTotal() {
        let sum = 0;
        this.data.items.forEach((item) => {
            sum += item.cost;
            if (item.products) {
                item.products.forEach((product) => {
                    if (product.isAdded) {
                        sum += product.cost;
                    }
                });
            }
        });

        if (this.data.donation) {
            sum += this.data.donation.cost;
        }

        this.data.total = {
            cost: sum,
            visualCost: sum === 0 ? 'FREE' : `${this.data.currency}${Number(sum).toFixed(2)}`
        };
    }

    onDonationChange(value) {
        const donationVal = parseFloat(value) > 0 ? parseFloat(value) : 0;
        this.data.donation = this.getDonationObject(donationVal);
        this.calcTotal();
        this.render();
    }

    getDonationObject(donationVal) {
        if (donationVal === 0) {
            return null;
        }

        return {
            cost: donationVal,
            visualCost: `${this.data.currency}${donationVal}`
        };
    }

    getPriceRequestBody(product) {
        const result = {
            Id: product.id,
        };
        product.preparedOptions = basketManager.prepareItemOptions(product.options);
        if (product.preparedOptions.length) {
            result.Options = product.preparedOptions;
        }
        result.Quantity = 1;
        return result;
    }


    destroy() {
        super.destroy();

        for (let i = 0; i < this.productNodes.length; i++) {
            this.productNodes[i].removeEventListener('change', this.onProductChange);
        }
        this.container.classList.remove('js-payment-summary-inited');
    }
}



// WEBPACK FOOTER //
// ./app/components/payment-summary/js/generic.payment-summary.js